import {BehaviorSubject} from 'rxjs';
import {filter, map, startWith, shareReplay} from 'rxjs/operators';
import {array2Map} from '@/helper/array';

export const originalCurrencies$ = new BehaviorSubject([]);
export const currencies$ = new BehaviorSubject([]);
export const currenciesCache$ = currencies$.pipe(
  filter((o) => o.length > 0),
  map((o) => array2Map(o, 'currency')),
  startWith(new Map()),
  shareReplay(1)
);

export const currenciesWithChain$ = currencies$.pipe(
  map((currencies) => currencies.filter((currency) => !!currency.chain)),
  startWith([])
);

export const currenciesCacheByCode$ = currencies$.pipe(
  filter((o) => o.length > 0),
  map((o) => array2Map(o, 'code')),
  startWith(new Map()),
  shareReplay(1)
);
